import clsx from 'clsx';
import styles from './LinearProgress.module.scss'

export default ({ className }) => (
  <div className={clsx(styles.progress, className)}></div>
)
